import React from 'react';

// Headings sit this far below the viewport top once scrolled to: the sticky
// header's height, matching the headings' scrollMarginTop (Markdown.jsx).
const HEADER_OFFSET = 140;

// The id of the section being read: the last heading whose top has scrolled
// above the sticky header, or the first heading before any has. Null until
// mounted — the server render (scripts/prerender.js) has no scroll position,
// so the table of contents first paints with nothing highlighted and hydrates
// cleanly.
export const useActiveHeading = (headings) => {
  const [active, setActive] = React.useState(null);
  const ids = headings.map(heading => heading.id).join('|');

  React.useEffect(() => {
    if (!headings.length)
      return undefined;
    const update = () => {
      let current = headings[0].id;
      for (const { id } of headings) {
        const element = document.getElementById(id);
        if (element && element.getBoundingClientRect().top < HEADER_OFFSET)
          current = id;
      }
      setActive(current);
    };
    // A frame later, so the body has rendered and the headings exist.
    const frame = window.requestAnimationFrame(update);
    window.addEventListener('scroll', update, { passive: true });
    return () => {
      window.cancelAnimationFrame(frame);
      window.removeEventListener('scroll', update);
    };
  }, [ids]);

  return active;
};
